import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { MapLayout } from '@/components/layout/MapLayout';
import { LoadingScreen } from '@/components/ui/LoadingScreen';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

const MapPage = lazy(() => import('@/routes/MapPage'));
const FavoritesPage = lazy(() => import('@/routes/FavoritesPage'));
const HistoryPage = lazy(() => import('@/routes/HistoryPage'));
const NotFoundPage = lazy(() => import('@/routes/NotFoundPage'));

export default function App() {
  return (
    <ErrorBoundary>
      {/* Skip link for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-accent-500 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-navy-950"
      >
        İçeriğe geç
      </a>

      <Routes>
        <Route element={<MapLayout />}>
          <Route
            path="/"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <MapPage />
              </Suspense>
            }
          />
          <Route
            path="/favorites"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <FavoritesPage />
              </Suspense>
            }
          />
          <Route
            path="/history"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <HistoryPage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <NotFoundPage />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
